import React from 'react';


import useSearchWidget from '../../../hooks/useSearchWidget';
import usePrevious from '../../../hooks/usePrevious';
import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';
import scrollToTop from '../../../utils/scrollToTop';

import {nonNullable} from '../../../../types/type-guards';
import SearchWidgetUI from '../../../../stories/components/hotels/SRP/SearchWidgetUI/SearchWidgetUI';

const SearchWidget = ({isDetailsPage = false, isSrp = false}) => {
  const {
    checkin,
    checkout,
    destination,
    roomString,
    autosuggestHandler,
    updateQueryCaller,
  } = useSearchWidget();

  const prevDestinationId = usePrevious(destination?._id);
  const destinationChanged =
    nonNullable(prevDestinationId) &&
    nonNullable(destination?._id) &&
    prevDestinationId !== destination?._id;

  const openInNewTab = destinationChanged && isDetailsPage;

  const [onSearch] = useNavigateForSearchWidget();

  React.useEffect(() => {
    if (destinationChanged) {
      onSearch(openInNewTab, null, {}, true, [], true); // clearing filters on destination change
    }
  }, [destinationChanged, openInNewTab]);

  return (
    <SearchWidgetUI
      updateQueryCaller={updateQueryCaller}
      autosuggestHandler={autosuggestHandler}
      roomString={roomString}
      checkin={checkin}
      checkout={checkout}
      destination={destination}
      updateSearch={() => {
        onSearch(openInNewTab);
        scrollToTop();
      }}
    />
  );
};

export default SearchWidget;
